import React, { Fragment } from 'react'
import Header from '../Header'
import BrandProfile from '../../rds/brands/Profile'
import TrustedBrands from '../TrustedBrands'
import Footer from '../Footer'

const PublicBrandProfile = () => {
    return (
        <Fragment>
            <Header />
            <div className="public-page" style={{ minHeight: 'calc(100vh - 200px)', backgroundColor: '#f7faf8' }}>
                <BrandProfile />
            </div>
            <TrustedBrands />
            <Footer />
        </Fragment>
    )
}

export default PublicBrandProfile
